import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "legend-box" }
const _hoisted_2 = { id: "legend" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "query", -1)
const _hoisted_4 = { class: "bar" }
const _hoisted_5 = { class: "low" }
const _hoisted_6 = { class: "high" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "key", -1)
const _hoisted_8 = { class: "bar" }
const _hoisted_9 = { class: "low" }
const _hoisted_10 = { class: "high" }
const _hoisted_11 = {
  id: "legend-msg",
  class: "subtitle"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "color info:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["bar-contain", {
                        pos: _ctx.colorBy == 'row' || _ctx.colorBy == 'column' || _ctx.colorBy == 'position' || _ctx.colorBy == 'embed_norm' || _ctx.colorBy == 'token_length' || _ctx.colorBy == 'sent_length' || _ctx.colorBy == 'token_freq', cat: _ctx.colorBy == 'pos_mod_5', pun: _ctx.colorBy == 'punctuation'
                    }])
          }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.lowLabel()), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.highLabel()), 1)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["bar-contain k", {
                    pos: _ctx.colorBy == 'row' || _ctx.colorBy == 'column' || _ctx.colorBy == 'position' || _ctx.colorBy == 'embed_norm' || _ctx.colorBy == 'token_length' || _ctx.colorBy == 'sent_length' || _ctx.colorBy == 'token_freq', cat: _ctx.colorBy == 'pos_mod_5', pun: _ctx.colorBy == 'punctuation'
                }])
          }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.lowLabel()), 1),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.highLabel()), 1)
            ])
          ], 2)
        ], 512), [
          [_vShow, _ctx.colorBy != 'no_outline']
        ]),
        _createElementVNode("p", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(_ctx.colorMsg), 1)
        ])
      ], 512), [
        [_vShow, !_ctx.renderState]
      ])
    ]),
    _: 1
  }))
}